import { NgClass } from '@angular/common';
import type { InputSignal } from '@angular/core';
import {
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	input,
} from '@angular/core';

import type { StoryblokRichTextDoc } from '@storyblok/richtext';

import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import type { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { RichTextComponent } from '@valk-nx/storyblok/components/richtext/src/lib/rich-text';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import type { ColumnComponentAlignments } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	host: { ngSkipHydration: 'true' },
	selector: 'sb-heading-group',
	templateUrl: './heading-group.html',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [HeadingDirective, NgClass, RichTextComponent, StoryblokDirective],
})
export class HeadingGroupComponent extends StoryblokRootDirective {
	overline = input('');
	title: InputSignal<StoryblokRichTextDoc | string> = input.required<
		StoryblokRichTextDoc | string
	>();
	headingType = input<HeadingType>('h2');
	size = input<'sm' | 'md' | 'lg'>('md');
	isSection = input(false);
	alignment = input<ColumnComponentAlignments>('left');

	headingSize = computed(() => {
		switch (this.size()) {
			case 'sm':
				return 'heading-group heading-group-sm';
			case 'lg':
				return 'heading-group heading-group-lg';
			case 'md':
			default:
				return 'heading-group ';
		}
	});
}
